import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../components/tables/tableContext/TableContext";
import { DeliverySheetsDataInterface } from "../../../../redux/interfaces/expedition.interface";

import { getDateFormat } from "../../../../utils/parsers";

export const deliverySheetsTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Id borderou",
    value: "id_borderou",
  },
  {
    label: "Nod",
    value: "nodNume",
    minW: 125,
    withSearch: true,
  },

  {
    label: "Ruta",
    value: "ruta",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Data crearii",
    value: "data_crearii",
    minW: 125,
    withDatePicker: {
      withClearData: true,
    },
  },
];

export const getDeliverySheetsTableHeaderTableData = (
  data: DeliverySheetsDataInterface[],
): TableData[] =>
  data.map((item) => {
    return {
      id: item.id_borderou,
      crudData: item,
      data: [
        {
          title: item.id_borderou,
        },
        {
          title: item.nodNume,
        },
        {
          title: item.ruta,
        },
        {
          badges: [
            {
              badgeText: item.createdAt ? getDateFormat(item.createdAt) : "-",
              badgeColor: "light-info",
            },
          ],
        },
      ],
    };
  });
